import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59383fdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "product_view" }
const _hoisted_2 = { class: "headline" }
const _hoisted_3 = { class: "describe" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "remain" }
const _hoisted_6 = ["onClick"]

import { computed, markRaw, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import ProductContent from "./pages/ProductContent.vue";
import Mitt from "@/utils/mitt";
import routeHash from '@/constant/router_hash'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductView',
  setup(__props) {

const { t } = useI18n();

const StickyHeight = parseFloat(getComputedStyle(document.documentElement).fontSize) * 34

const scrollTop = ref(0)
const content = ref(null)
const navList = computed(() => [
    {
      title: t("product.L2L_NAV"),
      id: "L2L"
    },
    {
      title: t("product.L2A_NAV"),
      id: "L2A"
    },
    {
      title: t("product.RDHx_NAV"),
      id: "RDHx"
    },
    {
      title: t("product.OTHERS_NAV"),
      id: "others"
    },
]);
const currentProductId = ref(navList.value[0].id)

const scrollToProduct = (productId:string) => {
  document.getElementById(productId)?.scrollIntoView({
    behavior: 'smooth',
    block: "start"
  })
}

const updateProductId = (productId:string) => {
  currentProductId.value = productId
}

onMounted(() => {
    window.addEventListener('scroll', function() {  
      scrollTop.value = window.scrollY || document.documentElement.scrollTop;  
  });
  Mitt.on(routeHash.L2A_PRODUCT, () => scrollToProduct("L2A"))
  Mitt.on(routeHash.L2L_PRODUCT, () => scrollToProduct("L2L"))
  Mitt.on(routeHash.RDHx_PRODUCT, () => scrollToProduct("RDHx"))
  Mitt.on(routeHash.OTHERS_PRODUCT, () => scrollToProduct("others"))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("product.PRODUCT_DESCRIPTION")), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("product.PRODUCT_TITLE")), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "navbar",
        style: _normalizeStyle({
        'position': scrollTop.value > StickyHeight ? 'fixed' : 'absolute',
        'top': scrollTop.value > StickyHeight ? '5rem' : '2rem'
      })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (nav) => {
          return (_openBlock(), _createElementBlock("div", {
            key: nav.title
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (scrollToProduct(nav.id)),
              class: _normalizeClass(currentProductId.value === nav.id ? 'active_nav' : 'navItem' )
            }, _toDisplayString(nav.title), 11, _hoisted_6)
          ]))
        }), 128))
      ], 4),
      _createElementVNode("div", {
        class: "product_content",
        ref_key: "content",
        ref: content
      }, [
        _createVNode(ProductContent, { onUpdateProductId: updateProductId })
      ], 512)
    ])
  ]))
}
}

})